import React from "react";
import styles from "../../BorrowerDetails.module.css";
import CloseIcon from "@mui/icons-material/Close";
import { url } from "../../../../../App";
import { useState, useEffect } from "react";
import axios from "axios";
import CoapplicantDocument from "../SectionTwo/Components/Coapplicant/CoapplicantDocument";
import CoapplicantMultiDocs from "../SectionTwo/Components/Coapplicant/CoapplicantMultiDocs";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router";
import Cookies from 'js-cookie';

const docArray = [
  {
    doc: "collateral_misc_doc",
    state: "miscDocs",
  },
  {
    doc: "collateral_property_images",
    state: "propImage",
  },
];

const CollateralModal = ({ closeModal, details, closeLoader, openLoader, isDisbursed, isDownload, isDelete }) => {
  const [documents, setDocuments] = useState([]);
  const [miscDocuments, setMiscDocuments] = useState([]);
  const [propertyImg, setPropertyImg] = useState([]);

  const [documentExist, setDocumentExist] = useState({
    miscDocs: false,
    propImage: false,
  });

  const Navigate = useNavigate();

  const fetchDocuments = async (docName, docType) => {
    try {
      openLoader();
      const req = {
        token: Cookies.get('Token'),
        email: Cookies.get('Email'),
        collateral_id: details.collateral_id,
        doc_name: docName,
        doc_type: docType,
        collateral_borrower_uniqueno: localStorage.getItem("uniqueID"),
      };
      const res = await axios.post(url + "/collateral/viewdoc", req);
      closeLoader();
      if (!res.data.auth) return;
      return res.data.doc_base64;
    } catch (err) {
      console.log(err);
      closeLoader();
      return null;
    }
  };

  const downloadCollateralDocsHandler = async (docName, docType, name) => {
    //TODO setLoader(true);
    try {
      openLoader();
      const req = {
        token: Cookies.get('Token'),
        email: Cookies.get('Email'),
        collateral_id: details.collateral_id,
        doc_name: docName,
        doc_type: docType,
        collateral_borrower_uniqueno: localStorage.getItem("uniqueID"),
      };
      const res = await axios.post(url + "/collateral/downloaddoc", req);
      closeLoader();
      // console.log(req, res);
      //TODO setLoader(false);
      if (!res.data.auth) {
        toast.error(res.data.message);
        return;
      }
      if (req.doc_type === "pdf") {
        const downloadLink = document.createElement("a");
        const linkSource = `data:application/${req.doc_type};base64,${res.data.doc_base64}`;
        const fileName = `${req.collateral_id} ${docName}.${req.doc_type}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        const linkSource = `data:image/${req.doc_type};base64,${res.data.doc_base64}`;
        const downloadLink = document.createElement("a");
        const fileName = `${req.collateral_id} ${docName}.${req.doc_type}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    } catch (err) {
      console.log(err);
      closeLoader();
      return null;
    }
    //TODO setLoader(false);
  };

  const deleteCollateralDocHandler = async (docName, docType, location) => {
    let text = `Are you sure you want to delete ${docName} for ${details.collateral_id}?`;
    if (!window.confirm(text)) {
      return;
    }
    try {
      const request = {
        token: Cookies.get('Token'),
        email: Cookies.get('Email'),
        collateral_id: details.collateral_id,
        collateral_borrower_uniqueno: localStorage.getItem("uniqueID"),

        doc_arr: {
          location: location,
          doc_type: docType,
          doc_name: docName,
        },
      };
      console.log(request);

      const { data: response } = await axios.post(
        url + "/collateral/deletedoc",
        request
      );
      if (!response.auth) {
        if (response.logout) {
          toast.error(response.message);
          setTimeout(() => {
            Navigate("/");
          }, 1500);
        }
        toast.error(response.message);
        return;
      }

      toast.success(response.message);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      closeModal();
    } catch (error) {
      console.log(error);
      toast.error(error.message + "from console");
      return null;
    }
  };
  // const updateDocState = async (name, docName, docType) => {
  //   try {
  //     const doc = await fetchDocuments(docName, docType);
  //     //* Update using object //

  //     //* setDocuments((prevState) => ({
  //     //*   ...prevState,
  //     //*   [docField]: { docType, doc },
  //     //* }));

  //     //* Update using Array

  //     setDocuments((prevState) => [...prevState, { name, docType, doc }]);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  useEffect(() => {
    const collateralDocsHandler = async () => {
      docArray.forEach(({ doc, state }) => {
        const fieldVal = details[doc];
        if (fieldVal && fieldVal.length !== 0) {
          setDocumentExist((prevState) => ({
            ...prevState,
            [state]: true,
          }));
        }
      }); // console.log(details);

      const {
        collateral_legal_report: legalReport,
        collateral_valuation_report: valuationReport,
        collateral_property_doc: propertyDoc,
        collateral_mortgage_deed: mortgageDeed,
        collateral_index2: index2,
        collateral_doc_list: docList,
        collateral_misc_doc: miscDocs,
        collateral_search_report: searchReport,
        collateral_property_images: propertyImages,
      } = details;

      const updatedDocument = [];

      if (legalReport) {
        const doc = await fetchDocuments(
          legalReport.doc_name,
          legalReport.doc_type
        );
        updatedDocument.push({
          name: "Legal Report",
          docType: legalReport.doc_type,
          doc: doc,
          apiName: legalReport.doc_name,
          location: legalReport.location,
        });
      }
      if (valuationReport) {
        const doc = await fetchDocuments(
          valuationReport.doc_name,
          valuationReport.doc_type
        );
        updatedDocument.push({
          name: "Valuation Report",
          docType: valuationReport.doc_type,
          location: valuationReport.location,
          doc: doc,
          apiName: valuationReport.doc_name,
        });
      }
      if (propertyDoc) {
        const doc = await fetchDocuments(
          propertyDoc.doc_name,
          propertyDoc.doc_type
        );
        updatedDocument.push({
          location: propertyDoc.location,
          name: "Property Document",
          docType: propertyDoc.doc_type,
          doc: doc,
          apiName: propertyDoc.doc_name,
        });
      }
      if (mortgageDeed) {
        const doc = await fetchDocuments(
          mortgageDeed.doc_name,
          mortgageDeed.doc_type
        );
        updatedDocument.push({
          name: "Mortgage Deed",
          location: mortgageDeed.location,
          docType: mortgageDeed.doc_type,
          doc: doc,
          apiName: mortgageDeed.doc_name,
        });
      }
      if (index2) {
        const doc = await fetchDocuments(index2.doc_name, index2.doc_type);
        updatedDocument.push({
          name: "Index 2",
          docType: index2.doc_type,
          location: index2.location,
          doc: doc,
          apiName: index2.doc_name,
        });
      }
      if (searchReport) {
        const doc = await fetchDocuments(
          searchReport.doc_name,
          searchReport.doc_type
        );
        updatedDocument.push({
          location: searchReport.location,
          name: "Search Report",
          docType: searchReport.doc_type,
          doc: doc,
          apiName: searchReport.doc_name,
        });
      }
      if (details.collateral_vetting_report) {
        const doc = await fetchDocuments(
          details.collateral_vetting_report.doc_name,
          details.collateral_vetting_report.doc_type
        );
        updatedDocument.push({
          location: details.collateral_vetting_report.location,
          name: "Vetting Report",
          docType: details.collateral_vetting_report.doc_type,
          doc: doc,
          apiName: details.collateral_vetting_report.doc_name,
        });
      }
      if (details.collateral_bt_soa) {
        const doc = await fetchDocuments(
          details.collateral_bt_soa.doc_name,
          details.collateral_bt_soa.doc_type
        );
        updatedDocument.push({
          location: details.collateral_bt_soa.location,
          name: "BT SOA",
          docType: details.collateral_bt_soa.doc_type,
          doc: doc,
          apiName: details.collateral_bt_soa.doc_name,
        });
      }
      if (details.collateral_bt_fc_letter) {
        const doc = await fetchDocuments(
          details.collateral_bt_fc_letter.doc_name,
          details.collateral_bt_fc_letter.doc_type
        );
        updatedDocument.push({
          location: details.collateral_bt_fc_letter.location,
          name: "BT FC Letter",
          docType: details.collateral_bt_fc_letter.doc_type,
          doc: doc,
          apiName: details.collateral_bt_fc_letter.doc_name,
        });
      }
      if (details.collateral_bt_lod) {
        const doc = await fetchDocuments(
          details.collateral_bt_lod.doc_name,
          details.collateral_bt_lod.doc_type
        );
        updatedDocument.push({
          location: details.collateral_bt_lod.location,
          name: "BT LOD",
          docType: details.collateral_bt_lod.doc_type,
          doc: doc,
          apiName: details.collateral_bt_lod.doc_name,
        });
      }
      if (details.collateral_bt_release_deed) {
        const doc = await fetchDocuments(
          details.collateral_bt_release_deed.doc_name,
          details.collateral_bt_release_deed.doc_type
        );
        updatedDocument.push({
          location: details.collateral_bt_release_deed.location,
          name: "BT Release Deed",
          docType: details.collateral_bt_release_deed.doc_type,
          doc: doc,
          apiName: details.collateral_bt_release_deed.doc_name,
        });
      }
      if (details.collateral_bt_noc_ndc) {
        const doc = await fetchDocuments(
          details.collateral_bt_noc_ndc.doc_name,
          details.collateral_bt_noc_ndc.doc_type
        );
        updatedDocument.push({
          location: details.collateral_bt_noc_ndc.location,
          name: "BT NOC/NDC",
          docType: details.collateral_bt_noc_ndc.doc_type,
          doc: doc,
          apiName: details.collateral_bt_noc_ndc.doc_name,
        });
      }
      if (docList) {
        const doc = await fetchDocuments(docList.doc_name, docList.doc_type);
        updatedDocument.push({
          name: "Document List",
          docType: docList.doc_type,
          doc: doc,
          apiName: docList.doc_name,
        });
      }
      if (miscDocs) {
        const miscDocsArr = await Promise.all(
          miscDocs.map(async (data) => {
            return {
              doc: await fetchDocuments(
                data.doc_name,
                data.doc_type,
                data.location
              ),
              docType: data.doc_type,
              location: data.location,
              apiName: data.doc_name,
            };
          })
        );
        setMiscDocuments(miscDocsArr);
      }
      if (propertyImages) {
        const propertyImgArr = await Promise.all(
          propertyImages.map(async (data) => {
            return {
              doc: await fetchDocuments(
                data.doc_name,
                data.doc_type,
                data.location
              ),
              docType: data.doc_type,
              location: data.location,
              apiName: data.doc_name,
            };
          })
        );
        setPropertyImg(propertyImgArr);
      }

      setDocuments(updatedDocument);

      //* Another Method===============================

      //? if (legalReport) {
      //?   await updateDocState(
      //?     "Legal Report",
      //?     legalReport.doc_name,
      //?     legalReport.doc_type
      //?   );
      //? }
      //?
      //? if (valuationReport) {
      //?   console.log(valuationReport);
      //?   await updateDocState(
      //?     "Valuation Report",
      //?     valuationReport.doc_name,
      //?     valuationReport.doc_type
      //?   );
      //? }
      //? if (propertyDoc) {
      //?   console.log(propertyDoc);
      //?   await updateDocState(
      //?     "Property Document",
      //?     propertyDoc.doc_name,
      //?     propertyDoc.doc_type
      //?   );
      //? }
      //? if (mortgageDeed) {
      //?   console.log(mortgageDeed);
      //?   await updateDocState(
      //?     "Mortgage Deed",
      //?     mortgageDeed.doc_name,
      //?     mortgageDeed.doc_type
      //?   );
      //? }
      //? if (index2) {
      //?   console.log(index2);
      //?   await updateDocState("Index 2", index2.doc_name, index2.doc_type);
      //? }
      //? if (docList) {
      //?   console.log(docList);
      //?   await updateDocState(
      //?     "Document List",
      //?     docList.doc_name,
      //?     docList.doc_type
      //?   );
      //? }
      //*================================
    };
    collateralDocsHandler();
    //eslint-disable-next-line
  }, [details]);

  console.log(documentExist);

  return (
    <>
      <ToastContainer />
      <div className={styles.coapplicantDocumentsModal}>
        <div
          className={styles.coapplicantDocumentsModaOverlay}
          onClick={(e) => e.target === e.currentTarget && closeModal()}
        >
          <div
            className={styles.coapplicantDocumentsModalContent}
            // onContextMenu={contextMenuHandler}
          >
            <h3>Collateral Documents</h3>
            {documents?.map((data) => {
              return (
                <CoapplicantDocument
                  key={data.apiName}
                  name={data.name}
                  doc={data.doc}
                  docType={data.docType}
                  download={downloadCollateralDocsHandler}
                  deleteDoc={deleteCollateralDocHandler}
                  apiName={data.apiName}
                  location={data.location}
                  isDisbursed={isDisbursed}
                  isDownload={isDownload}
                  isDelete={isDelete}
                />
              );
            })}
            {documentExist.miscDocs && (
              <CoapplicantMultiDocs
                name={"Misc Documents"}
                doc={miscDocuments}
                download={downloadCollateralDocsHandler}
                deleteDoc={deleteCollateralDocHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {documentExist.propImage && (
              <CoapplicantMultiDocs
                name={" Property Images"}
                doc={propertyImg}
                download={downloadCollateralDocsHandler}
                deleteDoc={deleteCollateralDocHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            <CloseIcon className={styles.CloseIcon} onClick={closeModal} />
          </div>
        </div>
      </div>
    </>
  );
};

export default CollateralModal;
